export default Object.freeze({
    ROLE_SUPER_ADMIN: 1,
    DASHBOARD : 1,
    PATIENTS : 2,
    APPOINTMENT: 3,
    PRESCRIPTION_FOLLOWUP: 4,
    INVOICES: 5,
    OT_SCHEDULE: 6,
    OT_BILL: 7,
    FILE_MANAGER: 8,
    LENS: 9,
    OT_COUNSELING: 10,
    INVESTIGATION: 11,
    HR: 12,
    LEDGER: 13,
    DOCTORS: 14,
    USERS_ROLES: 15,
    SMS: 16,
    CARD: 17,
    STUDY_SYSTEM: 18,
    REPORTS: 19,
    CABIN_BOOKING_LIST: 20,
    ADMINISTRATIVE_SETUP: 21,
    INSTITUTE: 22,
    HOSPITAL_OPTIC_SUMMARY: 23,
    PATIENT_LIST_LOGS: 24,
    PATIENT_CREATE_EDIT: 25,
    PATIENT_DETAILS: 26,
    EDIT_PHONE_NUMBER: 27,
    PRINT_MYOPIA_FORM: 28,
    MYOPIA_SAVE_FORM_DATA: 29,
    APPOINTMENT_CREATE: 30,
    APPOINTMENT_STATUS_CHANGE: 31,
    PRESCRIPTION_CREATE: 32,
    PRESCRIPTION_LIST: 33,
    PRESCRIPTION_EDIT: 34,
    PRESCRIPTION_VIEW: 35,
    LENS_PRESCRIPTION_ADVICE_LIST: 36,
    PRESCRIPTION_FOLLOWUP_LIST: 37,
    PRESCRIPTION_FOLLOWUP_ADD_EDIT_DELETE: 38,
    INVOICE_LIST: 39,
    INVOICE_EDIT: 40,
    CREATE_CONSULTATION_INVOICE: 41,
    CREATE_INVESTIGATION_INVOICE: 42,
    CREATE_LASER_INVOICE: 43,
    CREATE_PATHOLOGY_INVOICE: 44,
    CREATE_OVERSEAS_INVOICE: 45,
    DUE_LIST: 46,
    DUE_COLLECT: 47,
    PATHOLOGY_DUE_LIST: 48,
    PATHOLOGY_DUE_COLLECT: 49,
    ALL_REFUNDS_LIST: 50,
    REFUNDS_REVOKE: 51,
    VOID_LIST: 52,
    VOID_INVOICE_CREATE: 53,
    DOCTOR_INTERNAL_REFERRAL_LIST: 54,
    DOCTOR_INTERNAL_REFERRAL_LIST_EDIT: 55,
    DOCTOR_INTERNAL_REFERRAL_LIST_DELETE: 56,
    REF_INVOICE_OVERSEAS_LIST: 57,
    REF_PATIENT_SOURCE_HISTORY_LIST: 58,
    REF_PATIENT_SOURCE_PAYMENT_TO_HOSPITAL: 59,
    OT_SCHEDULE_CREATE_EDIT_REGISTRATION_RESCHEDULE: 60,
    OT_SCHEDULE_REGISTRATION_DETAILS: 61,
    OT_RECEIVE_AMOUNT: 62,
    OT_ALL_LIST: 63,
    OT_BILL_GENERATE: 64,
    OT_CANCEL_CREATE: 65,
    OT_BILL_REFUND: 66,
    OT_OPERATION_LIST: 67,
    OT_INJECTION_LIST: 68,
    OT_LASER_LIST: 69,
    OT_ADVANCE_LIST: 70,
    OT_DUE_LIST: 71,
    OT_CANCEL_LIST: 72,
    INVESTIGATION_FILE_UPLOAD: 73,
    QR_CODE_DATA_LIST: 74,
    QR_CODE_DATA_CREATE_EDIT_DELETE: 75,
    LENS_ITEM_LIST: 76,
    LENS_ITEM_CREATE: 77,
    LENS_ITEM_EDIT: 78,
    LENS_USED_REPORT_LIST: 79,
    COUNSELING_DASHBOARD: 80,
    COUNSELING_HISTORY_DETAILS: 81,
    ADD_NEW_COUNSELING: 82,
    COUNSELING_ADD_NOTE: 83,
    COUNSELING_FOLLOWUP: 84,
    COUNSELING_INCENTIVE: 85,
    COUNSELING_REPORT: 86,
    INVESTIGATION_INDIVIDUAL_LIST: 87,
    ADD_REPORT_INVESTIGATION_DATA: 88,
    INVESTIGATION_ADVICE: 89,
    INVESTIGATION_REPORT_DELIVERY: 90,
    HR_EMPLOYEE_LIST: 91,
    HR_EMPLOYEE_CREATE_EDIT: 92,
    HR_DEPARTMENT_LIST: 93,
    HR_DEPARTMENT_CREATE_EDIT: 94,
    HR_DESIGNATION_LIST: 95,
    HR_DESIGNATION_CREATE_EDIT: 96,
    PATIENT_SOURCE_LEDGER: 97,
    HOSPITAL_LEDGER: 98,
    DOCTOR_LIST: 99,
    DOCTOR_CREATE_EDIT: 100,
    DOCTOR_APPOINTMENT_SCHEDULE_CREATE_EDIT: 101,
    DOCTOR_APPOINTMENT_SCHEDULE_DETAILS: 102,
    DOCTOR_APPOINTMENT_NOTE_OFF_DATE_CREATE_EDIT: 103,
    DOCTOR_LEDGER: 104,
    DOCTOR_PAYMENT_STATEMENT: 105,
    DOCTOR_GET_PAYMENT: 106,
    DOCTOR_PAYMENT_LIST: 107,
    DOCTOR_PATIENTS: 108,
    USER_LIST: 109,
    USER_CREATE_EDIT: 110,
    USER_LEDGER: 111,
    ROLE_LIST: 112,
    ROLE_CREATE_EDIT: 113,
    SMS_DELIVERY_REPORT: 114,
    SMS_CAMPAIGN: 115,
    CARD_DASHBOARD: 116,
    CARD_CREATE: 117,
    CARD_LIST: 118,
    CARD_DETAILS: 119,
    CARD_ASSIGN_LIST: 120,
    CARD_NEW_ASSIGN: 121,
    CARD_CALL_STATUS_UPDATE: 122,
    CARD_SELL_DATE_ADD: 123,
    STUDY_SYSTEM_DASHBOARD: 124,
    STUDY_GROUP_LIST: 125,
    PAYMENT_METHOD_REPORT: 126,
    INVOICE_REPORT: 127,
    DR_CONTRIBUTION_REPORT: 128,
    ACTIVE_PATIENTS_REPORT: 129,
    DAILY_ACCOUNTING: 130,
    INVESTIGATION_REFERRAL_REPORT: 131,
    PATHOLOGY_REPORT: 132,
    BOOKING_LIST: 133,
    CABIN_BOOKING_CREATE: 134,
    CABIN_BOOKING_CHECKOUT: 135,
    CABIN_LIST: 136,
    PAYMENT_METHOD_SETUP: 137,
    PAYMENT_METHOD_CREATE_EDIT: 138,
    OT_ROOM_SETUP: 139,
    OT_ROOM_CREATE_EDIT: 140,
    INVESTIGATION_SETUP: 141,
    INVESTIGATION_SETUP_CREATE_EDIT: 142,
    FEE_RATIO_SETUP: 143,
    FEE_RATIO_EDIT: 144,
    CORPORATE_CLIENT_SETUP: 145,
    CORPORATE_CLIENT_SETUP_CREATE_EDIT: 146,
    CHAMBER_INFO: 147,
    CHAMBER_INFO_EDIT: 148,
    OPTIC_LENS_SETUP: 149,
    OPTIC_LENS_SETUP_CREATE_EDIT: 150,
    OT_ITEMS_SETUP: 151,
    OPERATION_LIST: 152,
    OPERATION_CREATE_EDIT: 153,
    OT_BILL_HEAD_LIST: 154,
    OT_BILL_HEAD_CREATE_EDIT: 155,
    OT_LENS_SETUP_LIST: 156,
    OT_LENS_SETUP_CREATE: 157,
    OT_INCENTIVE_SETUP: 158,
    OT_INCENTIVE_CREATE_EDIT: 159,
    OT_INCENTIVE_DELETE: 160,
    PATHOLOGY_SETUP: 161,
    ALL_INSTITUTE: 162,
    INSTITUTE_CREATE_EDIT: 163,
    INSTITUTE_DELETE: 164,
    STUDENTS: 165,
    STUDENT_CREATE_EDIT: 166,
    ROLE_DELETE: 167,
    OT_REFERRAL_REPORT: 168,
    UPLOAD_FILE_LIST: 169,
    OT_STORE: 170,
    OT_PRODUCT_LIST: 171,
    OT_PRODUCT_ADD_EDIT: 172,
    OT_PURCHASE_ORDERS: 173,
    OT_PURCHASE_ORDER_CREATE_EDIT: 174,
    OT_LENS_BOOKED_LIST: 175,
    OT_LENS_BOOKED_CHECK: 176,
    OT_LENS_REPLACE: 177,
    MANUFACTURER_LIST: 178,
    MANUFACTURER_ADD_EDIT: 179,
    VENDOR_LIST: 180,
    VENDOR_ADD_EDIT: 181,
});